/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonBadge from "components/ArgonBadge";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

const parentsProfileTableData = (students) => {
  if (students === undefined) {
    return parentsProfileTableData;
  }
  const studentList = Array.isArray(students) ? students : [];
  const rows = studentList.map((student, index) => ({
    sno: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {index + 1}
      </ArgonTypography>
    ),
    "student Name": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {student.name || student.fullName || "N/A"}
      </ArgonTypography>
    ),
    Gender: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {student.gender || "N/A"}
      </ArgonTypography>
    ),
    "Date of Birth": (
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {student.dob ? new Date(student.dob).toLocaleDateString() : "N/A"}
      </ArgonTypography>
    ),
    "School/College/University Name": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {student.schoolName || student.institution || "N/A"}
      </ArgonTypography>
    ),
    "Preferred Time Duration": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {student.preferredTimeDuration || "N/A"} mins
      </ArgonTypography>
    ),
    "Tuition Tenure": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {student.noOfClassesPerWeek || "N/A"} classes/week
      </ArgonTypography>
    ),
    "mode Of Tuition": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {student.modeOfTuition || "N/A"}
      </ArgonTypography>
    ),
    "Tutors Level": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {student.tutorLevel || "N/A"}
      </ArgonTypography>
    ),
  }));

  return {
    columns: parentsProfileTableData.columns,
    rows,
  };
};

parentsProfileTableData.columns = [
  { name: "sno", align: "center" },
  { name: "student Name", align: "left" },
  { name: "Gender", align: "left" },
  { name: "Date of Birth", align: "left" },
  { name: "School/College/University Name", align: "left" },
  { name: "Preferred Time Duration", align: "left" },
  { name: "Tuition Tenure", align: "left" },
  { name: "mode Of Tuition", align: "center" },
  // { name: "Tutors Level", align: "left" },
];

parentsProfileTableData.rows = [
  {
    sno: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {1}
      </ArgonTypography>
    ),
    "student Name": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        Arun Yadav
      </ArgonTypography>
    ),
    Gender: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {"Male"}
      </ArgonTypography>
    ),
    "Date of Birth": (
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {"01-01-2000"}
      </ArgonTypography>
    ),
    "School/College/University Name": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {"ABC University"}
      </ArgonTypography>
    ),
    "Preferred Time Duration": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {"Morning"}
      </ArgonTypography>
    ),
    "Tuition Tenure": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {" 1 year"}
      </ArgonTypography>
    ),
    "mode Of Tuition": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {"Online"}
      </ArgonTypography>
    ),
    "Tutors Level": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {"Intermediate"}
      </ArgonTypography>
    ),
  },
];

export default parentsProfileTableData;
